import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectStrategicInitiativesSelectedFYear } from '../selectors'
import { fYearSelected } from '../strategicInitiativesSlice'

export const useStrategicInitiativesFiscalYear = () => {
  const dispatch = useAppDispatch()
  const fYear = useSelector(selectStrategicInitiativesSelectedFYear)

  const setFYear = useCallback(
    (value: number) => {
      dispatch(fYearSelected(value))
    },
    [dispatch]
  )

  return { fYear, setFYear }
}
